export function MessageIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Button/Icon">
        <path
          id="Union"
          d="M13.7143 1.33334H2.28569C1.49807 1.33334 0.857117 1.9743 0.857117 2.76191V10.381C0.857117 11.1686 1.49807 11.8095 2.28569 11.8095H3.71426V14.1905C3.71426 14.3738 3.8195 14.54 3.98378 14.6195C4.04997 14.651 4.12045 14.6667 4.19045 14.6667C4.29664 14.6667 4.40188 14.6314 4.48807 14.5624L7.92902 11.8095H13.7143C14.5019 11.8095 15.1428 11.1686 15.1428 10.381V2.76191C15.1428 1.9743 14.5019 1.33334 13.7143 1.33334ZM7.99997 8.00001H4.19045C3.92712 8.00001 3.71426 7.78668 3.71426 7.52382C3.71426 7.26096 3.92712 7.04763 4.19045 7.04763H7.99997C8.26331 7.04763 8.47616 7.26096 8.47616 7.52382C8.47616 7.78668 8.26331 8.00001 7.99997 8.00001ZM11.8095 6.09525H4.19045C3.92712 6.09525 3.71426 5.88192 3.71426 5.61906C3.71426 5.3562 3.92712 5.14287 4.19045 5.14287H11.8095C12.0728 5.14287 12.2857 5.3562 12.2857 5.61906C12.2857 5.88192 12.0728 6.09525 11.8095 6.09525Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
